// src/pages/Cart/Components/CartPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaTrash, FaArrowRight, FaShoppingBag } from 'react-icons/fa';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import {
  increaseQty,
  decreaseQty,
  removeItem,
} from '../../../redux/features/Cart/cartSlice';

function CartPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { cartItems } = useSelector((state) => state.cart) || { cartItems: [] };

  const [promoCode, setPromoCode] = useState('');

  const totalCartPrice = cartItems.reduce(
    (total, item) => total + Number(item.price) * item.qty,
    0
  );

  const tax = 0;
  const finalPrice = totalCartPrice + tax;

  const applyPromo = () => {
    if (!promoCode.trim()) return;
    alert(`کد تخفیف "${promoCode}" ارسال شد برای بررسی`);
  };

  const goToCheckout = () => {
    if (cartItems.length > 0) {
      navigate('/shipping');
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen py-10 px-4 sm:px-6 lg:px-8 mt-4" dir="rtl" style={{ backgroundColor: '#F6F7FB' }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8 pb-5 border-b" style={{ borderColor: '#D9D9D9' }}>
            <h1 className="text-lg font-black flex items-center gap-3" style={{ color: '#292524' }}>
              <FaShoppingBag style={{ color: '#9EAD8C' }} />
              سبد خرید اریس گالری
            </h1>
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-sm hover:opacity-70 transition-colors"
              style={{ color: '#79716B' }}
            >
              <FaArrowRight size={14} />
              <span>بازگشت</span>
            </button>
          </div>
          <div className="text-center py-20 rounded-3xl border border-dashed" style={{ backgroundColor: '#F4F1EA', borderColor: '#D9D9D9' }}>
            <p className="mb-6" style={{ color: '#79716B' }}>سبد خرید شما فعلاً خالی است.</p>
            <button
              onClick={() => navigate('/')}
              className="px-8 py-3 rounded-xl font-bold hover:opacity-90 transition-all text-white"
              style={{ backgroundColor: '#9EAD8C' }}
            >
              فروشگاه
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-10 px-4 sm:px-6 lg:px-8 mt-4" dir="rtl" style={{ backgroundColor: '#F6F7FB' }}>
      <div className="max-w-7xl mx-auto">
        
        <div className="flex items-center justify-between mb-8 pb-5 border-b" style={{ borderColor: '#D9D9D9' }}>
          <h1 className="text-lg font-black flex items-center gap-3" style={{ color: '#292524' }}>
            <FaShoppingBag style={{ color: '#9EAD8C' }} />
            سبد خرید اریس گالری
          </h1>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm hover:opacity-70 transition-colors"
            style={{ color: '#79716B' }}
          >
            <FaArrowRight size={14} />
            <span>بازگشت</span>
          </button>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
          
          <div className="xl:col-span-3">
            <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-4 rounded-t-2xl font-bold items-center text-center text-white" style={{ backgroundColor: '#9EAD8C' }}>
              <div className="col-span-5 text-right">محصول</div>
              <div className="col-span-2">قیمت</div>
              <div className="col-span-2">تعداد</div>
              <div className="col-span-2">جمع جزء</div>
              <div className="col-span-1"></div>
            </div>

            <div className="space-y-4 md:space-y-0 md:border-x md:border-b md:rounded-b-2xl overflow-hidden md:shadow-none" style={{ borderColor: '#D9D9D9' }}>
              {cartItems.map((item) => (
                <React.Fragment key={`${item.product}-${item.selectedColor || 'no-color'}`}>
                  
                  <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-5 border-b items-center text-center" style={{ borderColor: '#D9D9D9' }}>
                    <div className="col-span-5 flex items-center gap-4 text-right min-w-0">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-20 h-20 rounded-lg object-cover shrink-0"
                        style={{ backgroundColor: '#F4F1EA' }}
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/80x80?text=No+Image';
                        }}
                      />

                      <div className="min-w-0">
                        <h3 className="font-bold text-sm mb-1 truncate" style={{ color: '#292524' }}>
                          {item.name}
                        </h3>

                        {item.selectedColorName && (
                          <div className="flex items-center gap-1">
                            <span className="text-[11px]" style={{ color: '#79716B' }}>رنگ:</span>
                            <span className="text-[11px]" style={{ color: '#79716B' }}>{item.selectedColorName}</span>
                            {item.selectedColor && (
                              <div
                                className="w-3 h-3 rounded-full border border-white"
                                style={{ backgroundColor: item.selectedColor }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-span-2 text-sm font-medium" style={{ color: '#292524' }}>
                      {Number(item.price).toLocaleString('fa-IR')} تومان
                    </div>

                    <div className="col-span-2 flex justify-center">
                      <div className="flex items-center rounded-lg p-1" style={{ backgroundColor: '#F4F1EA' }}>
                        <button
                          onClick={() =>
                            dispatch(increaseQty({ product: item.product, selectedColor: item.selectedColor }))
                          }
                          className="p-1 hover:opacity-70 transition-colors active:scale-95"
                          style={{ color: '#9EAD8C' }}
                          aria-label="افزایش تعداد"
                        >
                          <AiOutlinePlus size={14} />
                        </button>

                        <span className="px-3 font-bold text-sm" style={{ color: '#292524' }}>{item.qty}</span>

                        <button
                          onClick={() =>
                            dispatch(decreaseQty({ product: item.product, selectedColor: item.selectedColor }))
                          }
                          className="p-1 hover:text-red-500 transition-colors active:scale-95"
                          aria-label="کاهش تعداد"
                        >
                          <AiOutlineMinus size={14} />
                        </button>
                      </div>
                    </div>

                    <div className="col-span-2 text-sm font-black" style={{ color: '#8A9A7B' }}>
                      {(Number(item.price) * item.qty).toLocaleString('fa-IR')} تومان
                    </div>

                    <div className="col-span-1 flex justify-center">
                      <button
                        onClick={() =>
                          dispatch(removeItem({ product: item.product, selectedColor: item.selectedColor }))
                        }
                        className="hover:text-red-600 transition-colors"
                        style={{ color: '#79716B' }}
                        aria-label="حذف محصول"
                      >
                        <FaTrash size={14} />
                      </button>
                    </div>
                  </div>

                  <div className="md:hidden rounded-2xl border p-4 flex flex-col gap-4 shadow-sm" style={{ backgroundColor: '#FDFCFA', borderColor: '#D9D9D9' }}>
                    <div className="flex gap-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-24 h-24 rounded-xl object-cover"
                        style={{ backgroundColor: '#F4F1EA' }}
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/96x96?text=No+Image';
                        }}
                      />

                      <div className="flex-1 flex flex-col justify-between py-1 min-w-0">
                        <div className="flex justify-between items-start gap-2">
                          <h3 className="font-bold text-sm truncate" style={{ color: '#292524' }}>{item.name}</h3>
                          <button
                            onClick={() =>
                              dispatch(removeItem({ product: item.product, selectedColor: item.selectedColor }))
                            }
                            className="shrink-0 hover:text-red-600 transition-colors"
                            style={{ color: '#79716B' }}
                            aria-label="حذف محصول"
                          >
                            <FaTrash size={14} />
                          </button>
                        </div>

                        {item.selectedColorName && (
                          <div className="flex items-center gap-2">
                            <span className="text-[10px]" style={{ color: '#79716B' }}>رنگ:</span>
                            <span className="text-[10px]" style={{ color: '#79716B' }}>{item.selectedColorName}</span>
                            {item.selectedColor && (
                              <span
                                className="w-3.5 h-3.5 rounded-full border block"
                                style={{ backgroundColor: item.selectedColor, borderColor: '#D9D9D9' }}
                              />
                            )}
                          </div>
                        )}

                        <div className="font-bold text-sm" style={{ color: '#9EAD8C' }}>
                          {Number(item.price).toLocaleString('fa-IR')} تومان
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-3 border-t border-dashed" style={{ borderColor: '#D9D9D9' }}>
                      <div className="flex items-center gap-3 rounded-xl p-1 px-2 border" style={{ backgroundColor: '#F4F1EA', borderColor: '#D9D9D9' }}>
                        <button
                          onClick={() =>
                            dispatch(increaseQty({ product: item.product, selectedColor: item.selectedColor }))
                          }
                          className="active:scale-95"
                          style={{ color: '#9EAD8C' }}
                          aria-label="افزایش تعداد"
                        >
                          <AiOutlinePlus size={16} />
                        </button>

                        <span className="font-black text-sm" style={{ color: '#292524' }}>{item.qty}</span>

                        <button
                          onClick={() =>
                            dispatch(decreaseQty({ product: item.product, selectedColor: item.selectedColor }))
                          }
                          className="active:scale-95"
                          style={{ color: '#9EAD8C' }}
                          aria-label="کاهش تعداد"
                        >
                          <AiOutlineMinus size={16} />
                        </button>
                      </div>

                      <div className="text-left leading-tight">
                        <p className="text-[10px]" style={{ color: '#79716B' }}>جمع کل:</p>
                        <p className="font-black text-base" style={{ color: '#8A9A7B' }}>
                          {(Number(item.price) * item.qty).toLocaleString('fa-IR')} تومان
                        </p>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            <div className="mt-8 p-4 sm:p-6 rounded-2xl border" style={{ backgroundColor: '#ffffff', borderColor: '#D9D9D9' }}>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
                <div className="flex-1 w-full relative">
                  <input
                    type="text"
                    placeholder="کد تخفیف را وارد کنید..."
                    className="w-full rounded-xl h-12 sm:h-14 px-4 sm:px-6 text-sm outline-none transition-all text-right"
                    style={{ backgroundColor: '#FDFCFA', border: '1px solid #D9D9D9', color: '#292524' }}
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = '#9EAD8C'}
                    onBlur={(e) => e.target.style.borderColor = '#D9D9D9'}
                  />
                  <span className="absolute left-4 sm:left-6 top-1/2 -translate-y-1/2 text-[10px] font-bold tracking-widest uppercase pointer-events-none" style={{ color: '#79716B' }}>
                    Promo
                  </span>
                </div>

                <button
                  type="button"
                  onClick={applyPromo}
                  className="w-full sm:w-48 h-12 sm:h-14 text-white rounded-xl font-bold hover:opacity-90 transition-all shadow-lg"
                  style={{ backgroundColor: '#9EAD8C', boxShadow: '0 8px 25px rgba(158, 173, 140, 0.25)' }}
                >
                  اعمال تخفیف
                </button>
              </div>

              <p className="mt-3 text-[11px] leading-5" style={{ color: '#79716B' }}>
                کد تخفیف را دقیق وارد کنید؛ حروف انگلیسی و اعداد حساس هستند.
              </p>
            </div>
          </div>

          <div className="xl:col-span-1">
            <div className="rounded-2xl border p-6 sticky top-24 shadow-sm" style={{ backgroundColor: '#FDFCFA', borderColor: '#D9D9D9' }}>
              <h2 className="text-lg font-bold mb-6 pb-4 border-b" style={{ color: '#292524', borderColor: '#D9D9D9' }}>
                خلاصه فاکتور
              </h2>

              <div className="space-y-4 mb-8">
                <div className="flex justify-between text-sm" style={{ color: '#79716B' }}>
                  <span>جمع کل محصولات</span>
                  <span>{totalCartPrice.toLocaleString('fa-IR')} تومان</span>
                </div>

                <div className="flex justify-between text-sm font-bold" style={{ color: '#8A9A7B' }}>
                  <span>پس کرایه</span>
                  <span>رایگان</span>
                </div>

                <div className="pt-4 border-t flex justify-between items-end" style={{ borderColor: '#D9D9D9' }}>
                  <span className="font-bold" style={{ color: '#292524' }}>مبلغ نهایی</span>
                  <div className="text-left">
                    <span className="text-2xl font-black leading-none" style={{ color: '#8A9A7B' }}>
                      {finalPrice.toLocaleString('fa-IR')}
                    </span>
                    <span className="text-[10px] block font-bold" style={{ color: '#79716B' }}>تومان</span>
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={goToCheckout}
                className="w-full text-white py-3 rounded-xl font-bold shadow-xl hover:translate-y-[-2px] hover:opacity-90 transition-all"
                style={{ backgroundColor: '#8A9A7B', boxShadow: '0 10px 30px rgba(138, 154, 123, 0.25)' }}
              >
                تکمیل سفارش و پرداخت
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CartPage;